import { render, staticRenderFns } from "./UpdateTagForm.vue?vue&type=template&id=233e5e02&scoped=true"
import script from "./UpdateTagForm.vue?vue&type=script&lang=js"
export * from "./UpdateTagForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateTagForm.vue?vue&type=style&index=0&id=233e5e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e5e02",
  null
  
)

export default component.exports